import * as _ from 'lodash';
import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit
} from '@angular/core';

@Directive({
  selector: '[appMatchHeightWidth]'
})
export class MatchHeightWidthDirective implements OnInit {
  @Input()
  minHeight?: number;

  @Input()
  maxHeight?: number;

  @Input()
  ratio?: number;

  @Input()
  center?: boolean;

  @HostListener('window:resize', [])
  onResize = _.throttle(this.setHeight, 100, {
    leading: true,
    trailing: true
  });

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.setHeight();
  }

  private setHeight() {
    if (this.minHeight || this.maxHeight) {
      let height = parseInt(
        (this.el.nativeElement.clientWidth / (this.ratio || 1.0)).toString(),
        10
      );

      if (this.minHeight) {
        height = Math.max(height, this.minHeight);
      }
      if (this.maxHeight) {
        height = Math.min(height, this.maxHeight);
      }

      this.el.nativeElement.style.height = `${height}px`;
    }

    if (this.center) {
      const width = parseInt(this.el.nativeElement.clientWidth, 10),
        parentWidth = parseInt(
          this.el.nativeElement.parentElement.parentElement.clientWidth,
          10
        );

      const offsetLeft = (parentWidth - width) / 2;

      this.el.nativeElement.style.marginLeft = `${offsetLeft}px`;
    }
  }
}
